<template>
    <section class="news">
        <div class="container">
            <div class="news-head">
                <div class="news-label">NEWS &amp; UPDATES</div>
                <h2 class="news-title">新闻动态</h2>
                <p class="news-sub">了解技明电器的最新动态与行业资讯</p>
            </div>

            <div class="layout">
                <!-- 左侧推荐卡 -->
                <div class="left">
                    <a class="promo" href="javascript:void(0)">
                        <div class="promo-img">
                            <img :src="promo.image" :alt="promo.title" />
                            <div class="badge" title="推荐">
                                <span>⧉</span>
                            </div>
                        </div>

                        <div class="promo-bottom">
                            <div class="date">
                                <div class="d">{{ promo.day }}</div>
                                <div class="ym">{{ promo.ym }}</div>
                            </div>
                            <div class="promo-text">
                                <div class="promo-title">{{ promo.title }}</div>
                                <div class="promo-desc">{{ promo.desc }}</div>
                            </div>
                        </div>
                    </a>
                </div>

                <!-- 右侧tabs + 列表 -->
                <div class="right">
                    <div class="tabs">
                        <button v-for="t in tabs" :key="t.key" class="tab" :class="{ active: active === t.key }"
                            type="button" @mouseenter="active = t.key" @focus="active = t.key">
                            {{ t.label }}
                        </button>
                    </div>

                    <div class="list">
                        <a v-for="(item, idx) in activeList" :key="item.title + idx" class="row"
                            href="javascript:void(0)">
                            <div class="row-date">
                                <div class="row-day">{{ item.day }}</div>
                                <div class="row-ym">{{ item.ym }}</div>
                            </div>

                            <div class="row-body">
                                <div class="row-title">{{ item.title }}</div>
                                <div class="row-desc">{{ item.desc }}</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed, ref } from "vue";

const tabs = [
    { key: "news", label: "公司新闻" },
    { key: "product", label: "产品动态" },
    { key: "insight", label: "行业资讯" },
];

const active = ref("news");

// 左侧推荐卡
const promo = {
    image: require("../static/1.webp"),
    day: "18",
    ym: "2026-08",
    title: "技明电器持续完善制造体系，四大品类协同保障稳定交付",
    desc: "从家电、照明到塑料与五金，技明不断优化产线与品控流程，为客户提供更稳定的制造与交付支持。",
};

// 三组列表数据
const data = {
    news: [
        {
            day: "12",
            ym: "2026-08",
            title: "外贸订单顺利交付，进出口业务稳步推进",
            desc: "近期多批出口订单按计划完成生产与交付，自营与代理进出口业务保持良好节奏。",
        },
        {
            day: "28",
            ym: "2026-07",
            title: "客户到访洽谈，深化多元品类定制合作",
            desc: "多家客户来访工厂，围绕家电、照明等品类的新品定制与批量生产进行深入交流。",
        },
        {
            day: "09",
            ym: "2026-07",
            title: "强化品质管控，推动生产流程标准化",
            desc: "公司持续完善从原料到成品的全流程质检规范，进一步提升品质稳定性与一致性。",
        },
    ],
    product: [
        {
            day: "26",
            ym: "2026-06",
            title: "工业定位灯系列持续升级，适配更多应用场景",
            desc: "围绕产线装配、仓储分拣等场景，定位灯系列在产品稳定性与使用便利性上不断优化。",
        },
        {
            day: "15",
            ym: "2026-05",
            title: "照明灯具定制能力提升，支持工程类批量需求",
            desc: "结合灯具制造与工程应用经验，可为工程照明、特种照明项目提供定制配套。",
        },
        {
            day: "03",
            ym: "2026-05",
            title: "塑料、五金品类协同配套能力进一步增强",
            desc: "注塑与五金加工产线协同配合，为家电、灯具等产品提供更完整的零部件配套。",
        },
    ],
    insight: [
        {
            day: "20",
            ym: "2026-07",
            title: "小家电制造：品质与定制并重成为合作关键",
            desc: "随着消费需求多样化，OEM / ODM 定制与稳定品控成为客户选择制造伙伴的重要考量。",
        },
        {
            day: "06",
            ym: "2026-07",
            title: "工业照明应用场景持续拓宽",
            desc: "从基础照明到特种定位照明，工业场景对灯具的功能性与可靠性提出更高要求。",
        },
        {
            day: "18",
            ym: "2026-06",
            title: "外贸合作新趋势：从单品采购走向供应链协同",
            desc: "越来越多海外客户希望制造商在品类协同、品质管控与交付服务上提供一体化支持。",
        },
    ],
};

const activeList = computed(() => data[active.value] || []);
</script>

<style scoped>
.news {
    position: relative;
    padding: 92px 0;
    overflow: hidden;
}

.news::before {
    content: "";
    position: absolute;
    inset: 0;
    background: #f3f5f8;
    z-index: 0;
}

.news > .container {
    position: relative;
    z-index: 1;
}

.container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 24px;
}

.news-head {
    text-align: center;
    margin-bottom: 48px;
}

.news-label {
    display: inline-block;
    padding: 5px 16px;
    border-radius: 999px;
    background: #e8f1fc;
    color: #0a4f97;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 3px;
    margin-bottom: 16px;
}

.news-title {
    font-size: 34px;
    font-weight: 800;
    color: #102a43;
    margin: 0 0 12px;
}

.news-sub {
    font-size: 15px;
    color: #7b8a9c;
    margin: 0;
}

.layout {
    display: grid;
    grid-template-columns: 560px 1fr;
    gap: 34px;
    align-items: start;
}

/* 左侧推荐卡 */
.promo {
    display: block;
    background: #fff;
    border: 1px solid #eef1f5;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 18px 40px rgba(16, 42, 67, .08);
    transition: transform .25s ease, box-shadow .25s ease;
}

.promo:hover {
    transform: translateY(-4px);
    box-shadow: 0 24px 52px rgba(16, 42, 67, .12);
}

.promo-img {
    position: relative;
    height: 350px;
    background: #e9eef6;
    display: flex;
    align-items: center;
    justify-content: center;
}

.promo-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.badge {
    position: absolute;
    top: 12px;
    left: 12px;
    width: 34px;
    height: 34px;
    border-radius: 999px;
    background: rgba(0, 0, 0, .30);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.promo-bottom {
    display: grid;
    grid-template-columns: 110px 1fr;
    border-top: 1px solid #eef1f5;
    background: #fff;
}

.date {
    padding: 18px 14px;
    border-right: 1px solid #eef1f5;
    text-align: center;
    color: #8a8a8a;
}

.d {
    font-size: 48px;
    font-weight: 700;
    line-height: 1;
    color: #0a4f97;
}

.ym {
    margin-top: 10px;
    font-size: 14px;
}

.promo-text {
    padding: 18px;
}

.promo-title {
    font-size: 16px;
    font-weight: 800;
    color: #102a43;
    line-height: 1.6;
}

.promo-desc {
    margin-top: 10px;
    color: #5b6b7e;
    font-size: 13px;
    line-height: 1.9;
}

/* 右侧 tabs */
.tabs {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border: 1px solid #cfd8e3;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
}

.tab {
    height: 46px;
    border: 0;
    border-right: 1px solid #cfd8e3;
    background: #fff;
    cursor: pointer;
    font-size: 15px;
    color: #4a5568;
    transition: background .15s ease;
}

.tab:last-child {
    border-right: 0;
}

.tab.active {
    background: #0a4f97;
    color: #fff;
    font-weight: 800;
}

.list {
    margin-top: 18px;
}

.row {
    display: grid;
    grid-template-columns: 110px 1fr;
    gap: 18px;
    padding: 20px 0;
    border-bottom: 1px solid rgba(0, 0, 0, .08);
    text-decoration: none;
}

.row:last-child {
    border-bottom: 0;
}

.row-date {
    text-align: center;
    color: #8a8a8a;
}

.row-day {
    font-size: 46px;
    font-weight: 700;
    line-height: 1;
    color: #0a4f97;
}

.row-ym {
    margin-top: 10px;
    font-size: 14px;
}

.row-title {
    font-size: 15px;
    font-weight: 800;
    color: #102a43;
    transition: color .18s ease;
}

.row-desc {
    margin-top: 10px;
    font-size: 13px;
    color: #5b6b7e;
    line-height: 1.9;
}

.row:hover .row-title {
    color: #0a4f97;
}

/* 响应式 */
@media (max-width: 1100px) {
    .layout {
        grid-template-columns: 1fr;
    }

    .promo-img {
        height: 300px;
    }
}

@media (max-width: 520px) {
    .news {
        padding: 60px 0;
    }

    .news-title {
        font-size: 26px;
    }

    .promo-bottom {
        grid-template-columns: 92px 1fr;
    }

    .d {
        font-size: 40px;
    }

    .row {
        grid-template-columns: 92px 1fr;
    }

    .row-day {
        font-size: 40px;
    }
}
</style>
